import Api from "@/network/api";
import { defineStore } from "pinia";
import { httpRequest } from "@/network/request";
import { shareConfigType } from "@/types/enum";
import type {
  GlobalConfigResponse,
  mallShareCardConfigData,
  integralGiftConfigData,
  mallSearchConfigData,
  mallPopupConfigData,
  mallStartupPagePopupConfigData,
  mallShareConfigData,
} from "@/types/api";
import type { GlobalConfigItem } from "@/types/api";

interface GlobalConfig {
  mallPopupConfig: GlobalConfigItem<mallPopupConfigData>[];
  mallSearchConfig: GlobalConfigItem<mallSearchConfigData>[];
  integralGiftConfig: GlobalConfigItem<integralGiftConfigData>[];
  mallShareCardConfig: GlobalConfigItem<mallShareCardConfigData>[];
  mallShareConfig: GlobalConfigItem<mallShareConfigData>[];
  mallStartupPagePopupConfig: GlobalConfigItem<mallStartupPagePopupConfigData>[];
}

export const useGlobalStore = defineStore("global", {
  state: () => ({
    globalConfig: {
      mallPopupConfig: [],
      mallSearchConfig: [],
      integralGiftConfig: [],
      mallShareCardConfig: [],
      mallShareConfig: [],
      mallStartupPagePopupConfig: [],
    } as GlobalConfig, // 全局配置数据
    isNavigatingHome: false,
    afterLoginRoutePushData: {
      routeList: [],
      isNavigating: false,
    },
    keepAliveComponents: ["index"],
    isPad: false,
    historyStack: [], //浏览历史状态
    selectedAddress: null, // 当前选用的地址对象
    isHideH5TitleBar: null as boolean | null, // App 是否隐藏 H5 导航栏（null 表示尚未获取）
  }),

  getters: {
    getIsNavigatingHomeGetter: (state) => state.isNavigatingHome,
    getKeepAliveComponents: (state) => state.keepAliveComponents,
    getHistoryStack: (state) => state.historyStack,
    getSelectedAddress: (state) => state.selectedAddress,
    getShareCardConfig: (state) => {
      return (type: shareConfigType, id: number | string): mallShareCardConfigData | null => {
        if (!Array.isArray(state.globalConfig.mallShareCardConfig)) return null;
        if (id === undefined || id === null) return null;
        const config = state.globalConfig.mallShareCardConfig.find((item) => {
          const parsedData: mallShareCardConfigData = JSON.parse(item.data);
          return parsedData.objectType === type && parsedData.objectIDs.split(",").includes(id.toString());
        });

        if (config) {
          return JSON.parse(config.data);
        }
        return null;
      };
    },
  },

  actions: {
    fetchGlobalData({ CategoryCode }) {
      httpRequest({
        apiInfo: Api.GetGlobalConfigData,
        params: { CategoryCode },
      }).then(
        (res: GlobalConfigResponse) => {
          const configData = res.configData || {};
          const matrixConfigData = configData as GlobalConfigResponse["configData"] & {
            matrix_MallPopupConfig?: GlobalConfigItem<mallPopupConfigData>[];
            matrix_MallSearchConfig?: GlobalConfigItem<mallSearchConfigData>[];
            matrix_MallShareCardConfig?: GlobalConfigItem<mallShareCardConfigData>[];
            matrix_IntegralGiftConfig?: GlobalConfigItem<integralGiftConfigData>[];
            matrix_MallShareConfig?: GlobalConfigItem<mallShareConfigData>[];
            matrix_MallStartupPagePopupConfig?: GlobalConfigItem<mallStartupPagePopupConfigData>[];
          };

          this.globalConfig = {
            mallPopupConfig: matrixConfigData.matrix_MallPopupConfig || configData.mallPopupConfig || [],
            mallSearchConfig: matrixConfigData.matrix_MallSearchConfig || configData.mallSearchConfig || [],
            mallShareCardConfig: matrixConfigData.matrix_MallShareCardConfig || configData.mallShareCardConfig || [],
            integralGiftConfig: matrixConfigData.matrix_IntegralGiftConfig || configData.integralGiftConfig || [],
            mallShareConfig: matrixConfigData.matrix_MallShareConfig || [],
            mallStartupPagePopupConfig: matrixConfigData.matrix_MallStartupPagePopupConfig || [],
          };
        },
        (err) => {
          console.error("获取全局数据失败", err);
        },
      );
    },

    setIsPad(data) {
      this.isPad = data;
    },
    setSelectedAddress(data) {
      this.selectedAddress = data;
    },
  },
});
